import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../../../../../../../../util/assets';
import Button from '../../../../../../../../../../../components/global/Button';
import AddedToCartLabel from '../../../../../PhotoPurchasingOptions/AddedToCartLabel';

const propTypes = {
  className: PropTypes.string,
  eventCollage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    custom_print: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      preview_image: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  onEventCollageSelect: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  isInCart: PropTypes.bool,
};

const EventCollage = ({
  className,
  eventCollage,
  onEventCollageSelect,
  readOnly,
  isInCart,
}) => {
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-event-collage': true,
  });
  const { custom_print: customPrint } = eventCollage;
  const previewImage = customPrint.preview_image?.url;

  return (
    <div className={classes}>
      <div className="purchasing-option-item-thumb">
        <img
          width={previewImage ? 80 : 60}
          src={previewImage || getAsset('/plaque.svg')}
          alt=""
        />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <span className="purchasing-option-item-title">{customPrint.name}</span>

        <p className="text-sm lh-normal text-dark text-bold mb-2">
          Put your photos together in this special collage template!
        </p>

        {!readOnly && (
          <Button
            pill
            btnOutline={!isInCart}
            className={classNames({
              'purchasing-options-item-btn': true,
              'btn-purchase-options-in-cart': isInCart,
            })}
            btnStyle={classNames({
              primary: !isInCart,
              info: isInCart,
            })}
            data-testid="btn-event-collage-shop"
            onClick={() => {
              onEventCollageSelect(eventCollage);
            }}
          >
            {isInCart ? <AddedToCartLabel /> : 'Configure now'}
          </Button>
        )}
      </div>
    </div>
  );
};

EventCollage.propTypes = propTypes;

export default EventCollage;
